import React from 'react';
import { MiniTemplateCard } from 'components/general/TemplateCard';
import { IconType } from 'lib/data/model/dictionaries/IconTypes';
import { ComponentTemplate } from 'lib/data/model';
import { IBaseProps } from 'lib/data/interfaces';

interface ITemplateSelectorGroupProps extends IBaseProps {
    componentList: ComponentTemplate[];
    onCardClick(key: number): void;
    highlighted?: boolean;
    titleBarText?: string;
}
export const TemplateSelectorGroup = (props: ITemplateSelectorGroupProps) => {
    return (
        <div className="template-selector-group">
            {props.titleBarText ?
                props.titleBarText
                : null}
            {props.titleBarText ?
                < hr style={{ width: "100%" }} />
                : null}
            {props.componentList ?
                props.componentList.map((componentTemplate, key) => <MiniTemplateCard onClick={() => props.onCardClick(key)} highlighted={props.highlighted || false} key={key} title={componentTemplate.name} iconType={IconType.get(componentTemplate.$type)} />)
                : null}
        </div>
    );
}
